<div class="fd-box-error">
  <div class="fd-msg full-width">
      <span class="fd-circular"><i class="material-icons">error</i></span>
      <p>{{errorMessage}}</p>
  </div>
</div>